/* Gênero.
 *
 * O campo é texto livre no banco, e cada cliente escreveu do seu jeito ao
 * longo dos anos: existem registros com "M", com "Masculino" e com
 * "masculino". O portal e o app gravam a forma por extenso em minúsculo, e é
 * essa que vale daqui para a frente — o admin não pode inventar uma quarta.
 *
 * `valorDeGenero` traduz qualquer uma das formas antigas para a canônica, de
 * modo que o select abra já marcado em vez de "Selecione". Sem isso a tela
 * mostrava o campo vazio para quem tem gênero cadastrado — e salvar por cima
 * apagaria o dado sem ninguém perceber.
 */

export const OPCOES_GENERO = [
  { valor: 'masculino', rotulo: 'Masculino' },
  { valor: 'feminino', rotulo: 'Feminino' },
  { valor: 'nao_informado', rotulo: 'Prefiro não informar' }
]

export function valorDeGenero(bruto) {
  const v = String(bruto || '').trim().toLowerCase()
  if (!v) return ''
  if (v.startsWith('m')) return 'masculino'
  if (v.startsWith('f')) return 'feminino'
  return 'nao_informado'
}
